import { useLayoutEffect, useState } from 'react';

import styles from './animation.less';

interface UseAnimationTimeoutHook {
    (): { animationTimeout: number };
}

export const useAnimationTimeout: UseAnimationTimeoutHook = () => {
    const [animationTimeout, setAnimationTimeout] = useState(0);

    useLayoutEffect(() => {
        const animationTimeoutElement = document.createElement('div');
        animationTimeoutElement.classList.add(styles.itemAnimationTimeout);
        document.body.appendChild(animationTimeoutElement);
        const style = window.getComputedStyle(animationTimeoutElement);
        const animationTimeout = parseInt(style.getPropertyValue(`--animation-duration`), 10);
        if (Number.isInteger(animationTimeout)) {
            setAnimationTimeout(animationTimeout);
        }
        document.body.removeChild(animationTimeoutElement);
    }, []);

    return { animationTimeout };
};
